module.exports = __webpack_public_path__ + "img/kleisma4.59ee659f.jpg";